import { AjaxInfiniteScroll } from '../InfiniteScroll';

document.addEventListener('DOMContentLoaded', () => {
	const saleAdContainers =
		document.querySelectorAll<HTMLElement>('.saleAd__container');

	for (const container of saleAdContainers) {
		const endpoint = container.dataset['infiniteScrollEndpoint'];
		const next = parseInt(container.dataset['infiniteScrollNext'] ?? '');
		const limit = parseInt(container.dataset['infiniteScrollLimit'] ?? '');

		if (typeof endpoint !== 'string' || endpoint.trim() === '') {
			continue;
		}

		if (isNaN(next)) {
			console.error(
				'data-infinite-scroll-next attribute missing/invalid',
				container
			);
			continue;
		}

		if (isNaN(limit)) {
			console.error(
				'data-infinite-scroll-limit attribute missing/invalid',
				container
			);
			continue;
		}

		new AjaxInfiniteScroll(container, endpoint, next, limit);
	}
});
